import React, { useEffect } from 'react'
import ButtonClose from '../../atoms/button-close/button-close'
import logoGame1 from '../../../assets/images/play/logo_puzzle@big.png'
import logoGame2 from '../../../assets/images/play/logo_v-match@big.png'
import logoGame3 from '../../../assets/images/play/logo_mision-max-curv@big.png'
import doubleImg from '../../../assets/images/play/double.png'
import Button from '../../atoms/button/button'
import useMediaQuery from '../../../utils/useMediaQuery'
import './modalDoublePoints.scss'
import { triggerTag } from '../../../utils/taggeo'

type GameInfoOptions = { [key: string]: { name: string; image: string } }

const GameInfo: GameInfoOptions = {
  puzzle: {
    name: 'Puzzle',
    image: logoGame1,
  },
  'v-match': {
    name: 'V-Match',
    image: logoGame2,
  },
  'buenas-noches': {
    name: 'Misión Max Cur-V',
    image: logoGame3,
  },
}
export default function ModalDoublePoints({
  onClose,
  game,
  month,
}: {
  onClose: (success: boolean) => void
  game: string
  month: string
}) {
  const closeHandler = (success: boolean) => {
    onClose(success)
  }

  const isMobile = useMediaQuery()
  const onConfirmClick = (event: any) => {
    triggerTag('17A', {
      category: gameData.name,
      label: '¡Entendido!',
    })
    closeHandler(true)
  }
  const gameData = GameInfo[game]
  useEffect(() => {
    triggerTag('16A', {
      category: gameData.name,
      label: 'X2 puntos dobles',
    })
  }, [])
  return (
    <div className="f-modal-double-points">
      <div className="f-modal-double-points__wrapper">
        <ButtonClose onClick={() => closeHandler(false)} />
        <aside>
          <img
            className="double-icon"
            src={doubleImg}
            alt="double icon"
            title="Doble de puntos"
          />
          <img
            className="logo-icon"
            src={gameData.image}
            alt={gameData.name}
            height={220}
            title={gameData.name}
          />
        </aside>
        <aside>
          <h2 className="title">
            <i>Doble puntaje{isMobile && ' Juego'}</i>
          </h2>
          <p className="text">
            <i>
              Durante el mes de {month} al jugar {gameData.name} obtendrás Doble
              Puntaje
            </i>
          </p>

          <Button title="¡Entendido!" onClick={onConfirmClick}>
            ¡Entendido!
          </Button>
        </aside>
      </div>
    </div>
  )
}
